module.exports = __webpack_public_path__ + "32643447e8ca734bc0e3a85321207424.svg";